import React, { useContext } from "react";
import { Controller } from "react-hook-form";
import "./Multicheckbox.css"; // Ensure styles are applied
import { ThemeContext } from "../../../../..";

const CheckboxGroupWeb = ({ options, name, control, parentLabel, mobileAccess }) => {
  console.log("Received Parent Label:", parentLabel);
//   console.log(webaccess, "hasWebAccess");
  // Debugging
  const { theme } =useContext(ThemeContext);

  return (
    <div className="checkbox-group-container">
      {parentLabel && (
        <label className="checkbox-parent-label"  style={{ color: mobileAccess ? "" : "white" }}>
          {parentLabel}
        </label>
      )}
      <div className="checkbox-group div-space-adminrole">
        {options.map((option) => (
          <Controller
            key={`${name}.${option.name}`} // Ensure a unique key
            name={`${name}.${option.name}`} // ✅ Ensure unique name for each checkbox
            control={control}
            render={({ field: { onChange, value } }) => (
              <label
                className="checkbox-container"
                style={{ color: mobileAccess ? "" : theme === "light" ? "black" : "white" }} // Light gray when disabled
              >
                <span  style={{ color: mobileAccess ? "#6c659d" : theme === "light" ? "black" : "white" }} className="dynamic__checkbox--label label-adminrole">
                  {option.label}
                </span>
                <input
                  className="check-adminrole"
                  type="checkbox"
                  checked={value || false}
                  onChange={(e) => onChange(e.target.checked)}
                  disabled={mobileAccess}
                />
              </label>
            )}
          />
        ))}
      </div>
    </div>
  );
};

export default CheckboxGroupWeb;
